import React, {Component} from 'react';
import './css/homepage.css';


class AnimeHomepage extends Component {
  constructor (props) {
    super(props)
    this.state = {
      malId: ""
    }
    this.print = this.print.bind(this)
  }

  print() {
    this.props.history.push("/anime/" + this.state.malId)
  }

  render() {
    return (
      <div>
        < input type="text" 
          placeholder = "Enter MAL Id"
          className = "Text-Input"
          value={this.state.malId}
          ref={input => input && input.focus()}
          onChange={evt => this.setState({malId: evt.target.value})}/>
        {this.state.malId !== "" &&
          <button className="Answer-Submit-Btn" type = "button"
            onClick={this.print}>
            Go
          </button>
        }
        </div>
    );
  }
}

export default AnimeHomepage;



// WEBPACK FOOTER //
// ./src/components/animeHomepage.js